// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../file-type.d.ts" />
import fileTypeLib, { FileTypeResult } from 'file-type';

export function getFileType(
  input: Uint8Array | ArrayBuffer,
): FileTypeResult | null {
  const fileType = fileTypeLib(input);

  if (fileType && fileType.ext === 'msi') {
    // see discussion here https://github.com/sindresorhus/file-type/issues/162
    return null;
  }

  return fileType;
}
